<template>
  <div>
    <el-dialog title="文件下载" :visible.sync="disfiles" customClass="filedown" :append-to-body="true" :before-close="quxiao">
      <el-table :data="tableData2" border style="width: 100%" max-height="420" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="ctype_zbfile" label="文件类型" width="100"></el-table-column>
        <el-table-column prop="cname_zbfile" label="文件名称" min-width="180"></el-table-column>
        <el-table-column prop="name" label="操作" width="260">
          <template slot-scope="scope">
            <el-button size="mini" @click="regit(scope.row, scope.$index)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quxiao">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData2: { type: Array },
    disfiles: { type: Boolean },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    // 关闭弹框
    quxiao() {
      this.$emit("disfilesbtn", false);
    },
    regit(row, afff) {
      console.log(row);
      if (row.curl_zbfile != "") {
        // 下载文件
        //  let routeUrl = row.cfileurl;
        // window.open(routeUrl);
        const a = document.createElement("a");
        let urlblob = row.curl_zbfile;
        fetch(urlblob)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob);
            console.log(a.href);
            a.download = ""; // 下载文件的名字
            document.body.appendChild(a);
            a.click();
          });
      } else {
        this.$message.error("暂无文件");
      }
    },
  },
};
</script>